import { useState } from "react";

import { Icon } from "../../assets/icons/Icon";
import Button from "../mantine/button/Button";
import actionStyles from "../ui/dataTable/ActionColumn.module.scss";
import { ActionColumn } from "../ui/dataTable/DataTable";
import Modal from "../ui/modal/Modal";
import Spinner from "../ui/spinner/Spinner";
import styles from "./SiteSpeed.module.scss";
import EditRecordModal from "./dns/EditRecordModal";
import { makeEditInitialData } from "./helpers";
import type { ActionsDnsRecordProps } from "./types";

const ActionsSiteSpeedDomain: React.FC<ActionsDnsRecordProps> = ({
  tableRow,
  allTableRows,
  handleSubmit,
  onDelete,
  domain,
  disabled,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isPendingDelete, setIsPendingDelete] = useState(false);
  const deleteDnsRecord = () => {
    if (tableRow.id !== undefined) {
      setIsPendingDelete(true);

      if (onDelete) {
        onDelete(tableRow.id);
      }

      setIsPendingDelete(false);
      setIsDeleteModalOpen(false);
    }
  };

  return (
    <>
      <ActionColumn disabled={disabled}>
        {(close) => (
          <>
            <Button
              variant="menuItem"
              className={actionStyles.popoverItem}
              onClick={() => {
                close();
                setIsEditModalOpen(true);
              }}
            >
              Edit Record
            </Button>
            <Button
              variant="menuItem"
              className={actionStyles.popoverItem}
              onClick={() => {
                close();
                setIsDeleteModalOpen(true);
              }}
            >
              <span className={actionStyles.popoverItemTitle}>
                {isPendingDelete && <Spinner size="1rem" />}
                <span className={actionStyles.popoverItemRed}>
                  Delete Record
                </span>
              </span>
            </Button>
          </>
        )}
      </ActionColumn>

      <EditRecordModal
        isOpen={isEditModalOpen}
        closeModal={() => setIsEditModalOpen(false)}
        initialData={makeEditInitialData(tableRow)}
        handleSubmit={handleSubmit ?? (() => {})}
        domain={domain}
        allTableRows={allTableRows}
        mode="update"
      />

      <Modal
        isOpen={isDeleteModalOpen}
        closeModal={() => setIsDeleteModalOpen(false)}
        modalLabel={
          // @ts-expect-error TS2339 non-existing className
          <h3 className={styles.modalTitle}>
            {/*
             // @ts-expect-error TS2339 non-existing className */}
            <div className={styles.dangerIconWrapper}>
              <Icon iconName="DangerIcon" width="1rem" height="1rem" />
            </div>
            Delete DNS Record
          </h3>
        }
        buttonLabel="Apply"
        formId="deleteDnsRecordForm"
        actionButtonColor="danger"
        isLoading={isPendingDelete}
        action={deleteDnsRecord}
      >
        {/*
         // @ts-expect-error TS2339 non-existing className */}
        <div className={styles.deleteConfirmation}>
          <p>Are you sure you want to delete this DNS record?</p>
          {/*
           // @ts-expect-error TS2339 non-existing className */}
          <div className={styles.recordDetails}>
            <p>
              <strong>Type:</strong> {tableRow.type}
            </p>
            <p>
              <strong>Name:</strong> {tableRow.nameFQDN}
            </p>
            <p>
              <strong>Content:</strong> {tableRow.content}
            </p>
            <p>
              <strong>TTL:</strong> {tableRow.ttl}
            </p>
          </div>
          {/*
           // @ts-expect-error TS2339 non-existing className */}
          <p className={styles.warningText}>
            This action will be applied when you click Save. Deleting DNS
            records may affect your website's functionality.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default ActionsSiteSpeedDomain;
